import React, { useEffect, useRef, useState } from 'react';
import { CardBody, CardIcon, CardTitle, StepCard as StepCardRoot, StepNumber } from './styles';
import { ProcessStep } from './types';

type Props = {
  step: ProcessStep;
  stepNumber: number;
};

const StepCard: React.FC<Props> = ({ step, stepNumber }) => {
  const cardRef = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const Icon = step.icon;

  useEffect(() => {
    const el = cardRef.current;

    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <StepCardRoot ref={cardRef}>
      <CardIcon aria-hidden>
        <Icon isVisible={isVisible} />
      </CardIcon>
      <StepNumber>{stepNumber}</StepNumber>
      <CardTitle>{step.header}</CardTitle>
      <CardBody>{step.body}</CardBody>
    </StepCardRoot>
  );
};

export default StepCard;
